module.exports = __webpack_public_path__ + "img/rocket.20498624.png";